import { ReactElement, useMemo, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { breakpoints } from '../../theme/breakpoints'
import { useMediaQuery } from '@mui/material'
import { useUserStore } from '../../store/user/UserStore'
import { useBannerPromotionStore } from '../../store/promotion/BannerPromotionStore'
import { defaultTheme } from '../../theme'

export const BannerAdsHeader = (): ReactElement | null => {
  const location = useLocation()
  const pathNaname = location.pathname
  const userStore = useUserStore()
  const { isGeneralAdsEnabled } = useBannerPromotionStore()
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.laptop}px)`)
  const [visible, setVisible] = useState(true)
  const getZoneId = useMemo(() => {
    if (import.meta.env.VITE_MODE === 'production') {
      if (userStore?.country?.countryCode === 'US') {
        return 32
      } else if (userStore?.country?.countryCode === 'CA') {
        return 33
      }
    } else {
      return isDesktop ? 27 : 29
    }
    return undefined
  }, [isDesktop, userStore?.country?.countryCode])
  useEffect(() => {
    let timeout

    const interval = setInterval(
      () => {
        setVisible(false)
        timeout = setTimeout(() => setVisible(true), 5000)
      },
      15 * 60 * 1000
    )

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [])

  if (pathNaname === '/searchResults' || !isGeneralAdsEnabled() || !getZoneId) {
    return null
  }

  return (
    <Wrapper>
      {isDesktop ? (
        <div style={{ width: '1400px', height: '80px' }}>
          {visible && (
            <Iframe
              id="a4b874a2"
              name="a4b874a2"
              src={`https://ads.myplace4parts.com/www/delivery/afr.php?refresh=15&zoneid=${getZoneId}&cb=INSERT_RANDOM_NUMBER_HERE`}
              frameBorder="0"
              scrolling="no"
              width="100%"
              height="100%"
            ></Iframe>
          )}
        </div>
      ) : (
        <div style={{ width: '358px', height: '50px' }}>
          {visible && (
            <Iframe
              id="a05c7ff8"
              name="a05c7ff8"
              src={`https://ads.myplace4parts.com/www/delivery/afr.php?refresh=15&zoneid=${getZoneId}&cb=INSERT_RANDOM_NUMBER_HERE`}
              frameBorder="0"
              scrolling="no"
              width="100%"
              height="100%"
            ></Iframe>
          )}
        </div>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
  background-color: ${defaultTheme.colors.siteBackground};
  @media screen and (max-width: ${breakpoints.tabletXLarge}px) {
    margin-top: 60px;
    display: none;
  }
  @media print {
    display: none;
  }
`
const Iframe = styled.iframe`
  border: 0;
`
